import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import AppContext from '@/common/context/app.context'

import { getPreviewCurrency, getWidgetPreviewSettings } from '../helpers'
import useWidgetPreview from '../hooks/useWidgetPreview/useWidgetPreview'
import * as Styles from './styles'

const WidgetPreview = ({ view, appearance }) => {
  const { i18n } = useTranslation()
  const { info } = useContext(AppContext)

  const containerRef = useWidgetPreview({
    view,
    settings: getWidgetPreviewSettings(appearance),
    currency: getPreviewCurrency(info.selectedStore),
    locale: i18n.language,
  })

  return <Styles.Container ref={containerRef} view={view} data-testid={`${view}Preview`} />
}

export default WidgetPreview
